<template>
	<div class="new-present-form">
		<h2 class="new-present-form-title"
			:style="`color:${$appColors.info}`"
		>Nuevo Regalo</h2>
		<form>
			<label for="new-tool-name" class="name-input"
				:style="`color:${$appColors.info}`"
			>
				Nombre del regalo
				<input
					id="new-tool-name"
					class="new-survey-input"
					placeholder="Nombre"
					v-model="name"
				/>
			</label>
			<label for="new-tool-icon" class="name-input mr-0">
				Icono
				<input
					readonly
					id="new-tool-icon"
					class="new-survey-input"
					placeholder="Icono"
					:value="iconSelectedName"
				/>
			</label>
			<app-button
				icon="search"
				class="btn btn-search"
				:style="`background-color:${$appColors.primary}`"
				@click="selectingIcon"
			/>
			<label for="new-tool-point" class="name-input">
				Puntos
				<input
					id="new-tool-point"
					class="new-survey-input"
					placeholder="Puntos"
					v-model.number="points"
				/>
			</label>
			<app-button
				icon="add"
				class="btn btn-add"
				:style="`background-color:${$appColors.primary}`"
				:disabled="$v.$invalid"
				@click="createPresent"
			/>
		</form>
		<router-view name="selectingIcon"></router-view>
	</div>
</template>
<script>
import appButton from '@/components/shared/app-button';
import { mapGetters, mapState } from 'vuex';
import { minValue, required } from 'vuelidate/lib/validators';

function created() {
	this.name = this.presentName;
	this.points = this.presentPoints;
}

async function createPresent() {
	const action = this.flagEdit ? 'updatePresent' : 'createPresent';
	const msg = this.flagEdit ? 'actualizado un' : 'creado un nuevo';
	const body = this.buildBody();
	try {
		await this.$store.dispatch(`presentsConfiguration/${action}`, body);
		this.showNotification(`¡¡¡ Ha ${msg} premio exitosamente!!!`, 'success');
		this.clearNewPresentForm();
	} catch (err) {
		this.showGenericError();
	}
}

function buildBody() {
	const body = {
		iconGiftId: this.iconSelectedId,
		name: this.name,
		points: this.points,
	};
	if (this.flagEdit) {
		body.id = this.presentId;
	}
	return body;
}

function clearNewPresentForm() {
	this.name = '';
	this.points = 0;
	this.$store.dispatch('icon/selectIconAction', null);
}

function selectingIcon() {
	const newPresentData = {
		name: this.name,
		points: this.points,
	};
	this.$store.dispatch('presentsConfiguration/setNewPresentData', newPresentData);
	this.$store.dispatch('icon/selectIconAction', this.iconSelected);
	this.goTo('present-icons');
}

function flagEdit(newFlag) {
	if (newFlag) {
		this.name = this.presentName;
		this.points = this.presentPoints;
	}
}

function validations() {
	return {
		name: { required },
		points: {
			required,
			minValue: minValue(1),
		},
		iconSelectedName: { required },
	};
}

function data() {
	return {
		name: '',
		points: 0,
	};
}

export default {
	name: 'new-present-form',
	components: {
		appButton,
	},
	computed: {
		...mapGetters('presentsConfiguration', [
			'presentName',
			'presentPoints',
			'flagEdit',
		]),
		...mapState('presentsConfiguration', {
			presentId: state => state.editingPresentId,
		}),
		...mapState('icon', {
			iconSelectedName: state => state.selectedIcon && state.selectedIcon.name,
			iconSelectedId: state => state.selectedIcon && state.selectedIcon.id,
			iconSelected: state => state.selectedIcon,
		}),
	},
	created,
	data,
	methods: {
		buildBody,
		clearNewPresentForm,
		createPresent,
		selectingIcon,
	},
	validations,
	watch: {
		flagEdit,
	},
};
</script>
<style lang="scss" scoped>
.new-present-form {
	background-color: white;
	border: 1px solid #e9e9e9;
  	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
	margin-bottom: 21px;
	padding: 24px 33px;

	.new-present-form-title {
		font-family: font(bold);
		font-size: size(xlarge);
		margin-bottom: 22px;
	}

	form {
		align-items: flex-end;
		display: flex;

		label {
			font-size: size(small);

			input::placeholder {
				font-size: size(medium);
			}
		}

		.name-input {
			flex-basis: 20%;
			margin-right: 10px;
		}
	}

	.btn {
		color: white;
		font-family: font(bold);
		padding: 3.5px 10px;
		margin-right: 10px;
	}

	.btn-search {
		border-radius: 0 4px 4px 0;
	}

	.btn-add {
		border-radius: 4px;
	}
	@media (max-width: 950px) {
			width: 700px;
			display: flex;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/presents/new-present-form.vue